export const checkIsCompanyOnly = (selectedCountry?: string): boolean => {
  if (!selectedCountry) {
    return false;
  }
  const companyOnlyCountryCodes = ['AE'];
  return companyOnlyCountryCodes.some((charac) => selectedCountry.includes(charac));
};
